/**
 *  Accordion.tsx
 *  Disability Insurance Services
 *
 *  Created by Nathan Albrecht on Mon May 13 14:40:06 2019
 */
import React from "react";
import * as S from "../../constants/StringConstants";

import { Dialog, DialogContent, DialogContentText, DialogTitle, Icon } from "@mui/material";

import { Form as FinalForm } from "react-final-form";
import "./FormModal.scss";

export interface IFormModalState {
  open: boolean;
}

export interface IFormModalProps {
  onSubmit: (values: any) => void;
  launcher?: React.ReactNode;
  title?: string;
  saveLabel?: string;
  cancelLabel?: string;
  onCancel?: () => void;
  onClose?: () => void;
  values?: any;
  open?: boolean;
}

export default class FormModal<T> extends React.Component<IFormModalProps, IFormModalState> {
  private form: HTMLFormElement;

  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open || false,
    };

    this.submitForm = this.submitForm.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
  }

  static defaultProps = {
    saveLabel: S.FM_DEFAULT_SAVE,
    cancelLabel: S.FM_DEFAULT_CANCEL,
    title: "",
    values: {
      id: 0,
    },
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.open !== undefined && nextProps.open !== prevState.open) {
      return { open: nextProps.open };
    }
    return {};
  }

  submitForm(values: T) {
    this.props.onSubmit(values);
    this.handleClose();
  }

  handleCancel() {
    this.handleClose();

    if (this.props.onCancel) {
      this.props.onCancel();
    }
  }

  handleClose() {
    this.setState({ open: false });

    if (this.props.onClose) {
      this.props.onClose();
    }
  }

  handleOpen() {
    this.setState({ open: true });
  }

  render() {
    return (
      <>
        {this.props.launcher ? <div onClick={this.handleOpen}>{this.props.launcher}</div> : null}
        <Dialog
          open={this.state.open}
          onClose={this.handleCancel}
          PaperProps={{
            style: {
              width: "64rem",
              height: "auto",
              padding: "1rem 1rem",
            },
          }}>
          <DialogContentText align="right">
            <Icon style={{ cursor: "pointer" }} onClick={this.handleCancel}>
              clear
            </Icon>
          </DialogContentText>
          {this.props.title && <DialogTitle className="form-title">{this.props.title}</DialogTitle>}

          <DialogContent className="form-modal-v2">
            <FinalForm
              onSubmit={this.submitForm}
              initialValues={this.props.values}
              render={({ handleSubmit, valid }) => (
                <form onSubmit={handleSubmit}>
                  <div>{this.props.children}</div>
                  <div className="form-modal-v2__button-wrap">
                    <button type="button" onClick={this.handleCancel} className="button-v2 button-v2__secondary">
                      {this.props.cancelLabel}
                    </button>
                    {this.props.saveLabel && (
                      <button type="submit" disabled={!valid} className="button-v2 primary">
                        {this.props.saveLabel}
                      </button>
                    )}
                  </div>
                </form>
              )}
            />
          </DialogContent>
        </Dialog>
      </>
    );
  }
}
